module.exports = __webpack_public_path__ + "img/IMG_2907.7db049db.jpg";